import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { MacroStepId } from 'models';
import { Observable } from 'rxjs';

import { AppStoreFacadeService } from '../../../../facades/app-store-facade.service';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class BackUrlGuard implements CanDeactivate<CanComponentDeactivate> {

  constructor(
    private appStoreFacadeService: AppStoreFacadeService) {}

  canDeactivate(component: CanComponentDeactivate,
                currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot,
                nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (nextState && nextState.url.includes(MacroStepId.Initialization)) {
      this.appStoreFacadeService.navigation.goPrevious();
      return new Promise<boolean>((resolve) => {
        setTimeout(() => resolve(false), 500);
      });
    } else {
      return true;
    }
  }
}
